import useDictateContext from '/druid/internal/useDictateContext';

export default function useAbortable() {
  const { abortable } = useDictateContext();

  return [abortable];
}
